<div class="row">
  <div class="col-md-12 col-sm-12 justify-padding top-exposure-image-container">
    <a class="exposure-picture" (click)="openPostPage()">
      <blurry-backdrop-image [image]="topExposure.picture" (afterLoaded)="onLoadedImage()" (error)="onLoadedImageError()"></blurry-backdrop-image>
    </a>
    <div class="exposure-date">
      <span *ngIf="topExposure.date">{{formatExposureDate(topExposure.date)}}</span>
    </div>
  </div>
  <div class="col-md-12 col-sm-12 platform-title">
    <div class="d-flex flex-row justify-content-center align-items-center">
      <div class="{{getPlatformIcon().toLowerCase() + '-icon'}} icon-platform"></div>
      <div>
        <span class="exposure-type-title">
          {{exposureType}}
        </span>
      </div>
    </div>
  </div>
  <div class="col-md-12 col-sm-12">
    <div class="d-flex justify-content-center align-items-center">
      <span class="exposure-count">{{formatExposureNumber(topExposure.value)}}</span>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/top-exposures/top-exposure-item/top-exposure-item.component.html